import { Manager, Popper as ReactPopper, Reference } from 'react-popper';
import React, { useRef } from 'react';
import { createPortal } from 'react-dom';
import { RemoveScroll } from 'react-remove-scroll';
import { useMediaQueryContext } from '../../providers/MediaQueryProvider';
import { useOutsideClick } from '../../hooks/useOutsideClick';
import * as S from './Popper.styled';
export const Popper = ({ isOpen, children, referenceComponent, popperProps, style: childrenStyle, onClose, }) => {
    const mq = useMediaQueryContext();
    const containerRef = useRef(null);
    const zIndex = childrenStyle?.zIndex || 10;
    useOutsideClick(containerRef, () => {
        mq.tablet && onClose();
    });
    const renderPanel = ({ ref, style, placement: dataPlacement }) => {
        const styles = { ...style, ...childrenStyle, zIndex };
        return (React.createElement(S.Panel, { ref: ref, "data-placement": dataPlacement, style: styles }, children));
    };
    const renderChildren = (props) => {
        return (React.createElement(React.Fragment, null,
            createPortal(React.createElement(S.WrapperMobile, { id: "bottomsheet", "data-testid": "Popper.WrapperMobile", style: { zIndex } },
                React.createElement(S.Backdrop, { style: { zIndex, margin: 0 }, onClick: (event) => {
                        event.stopPropagation();
                        onClose?.();
                    } }),
                React.createElement(S.BottomInset, { style: { zIndex } }),
                renderPanel(props)), document.body),
            React.createElement(S.WrapperDesktop, { "data-testid": "Popper.WrapperDesktop", style: { zIndex } }, renderPanel(props))));
    };
    return (React.createElement(Manager, null,
        React.createElement("div", { ref: containerRef },
            React.createElement(Reference, null, ({ ref }) => React.createElement("div", { ref: ref }, referenceComponent)),
            React.createElement(RemoveScroll, { enabled: isOpen && !(mq.laptop || mq.desktop) }, isOpen ? React.createElement(ReactPopper, { ...popperProps }, renderChildren) : null))));
};
